<template>
  <div class="site-container">
    <div class="site-item" v-for="(site, index) in siteList" :key="index" @click="toDetail(site)">
      <img :src="site.coverIcon" alt="">
    </div>

    <div class="site-nav" @click="onSite">
      <img class="nav-img" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/plane.png" alt="">
      <span class="nav-text">展位导航</span>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        siteList: []
      }
    },
    mounted() {
      this.initData()
      this.getFigures()
    },
    methods: {
      initData() {
        this.$store.commit('changeToken', 'PBB+hfqyCn5u/Asp+KqEaro7AhH4z/+bW0+9qxZHTV3GqTTtK0xlBOZ/bJUKrMMzpQGrxvbaa1O+XC9IM1Esf+sq+GwKEVbFVC5oHf4ckhDvF0COJwODWI/otfPxmvDr8/lzo80KxYaPNqn7kEkK/5d3CRmNDUlQBGo9iBXFyJm9IcXhTs3UJ3PSx/3pyao67h18E1SncYIPukUmWlVAsHzhxLGBP9tOeJdS6oZ4RYKXIeoSHtEZefeF/0Ne5PpFdZjPGeTCeSLhi0QVNZ+70jSDR0ZiOfQJ5NTNtnT9EOJMGGPZkoevYDS/Wd1LcvI5xPT8hle8hE3TgEdYGc2Z+P4TQ3pEta1RRke+boQK/qNYu1LJkzJtNYIDRsf1bshJFAf5AxjrLvNiDx1pKcwNfgT1w5M/Dvv5yMKwTbI5yGQ=')
      },
      getFigures() {
        const params = {
          exhibitionId: 'b33d8960b7a245cb97146670283ac360',
          appId: '7e46f33c139246069a3c17c9f4847a25',
          languageType: 'cn',
          subjectType: 'VISITOR',
          sourceType: 2
        }
        this.$http.getFigures(params).then(res => {
          console.log(res)
          if (res.code === 1000) {
            const bannerMap = res.data.bannerMap
            this.siteList = bannerMap.ExhibitionHall3D
          }
        })
      },
      toDetail(site) {
        if (site.url) {
          window.location.href = site.url
        }
      },
      onSite() {
        window.location.href = 'https://szdt.3dqiye.com/boothplan?exhibitionId=08dd467e763b4db08aa1b40396d06e96'
        // window.location.href = "https://izt.eastfair.cn/h5-web/#/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/imaster/b33d8960b7a245cb97146670283ac360/66374311__1741092350083.jpg"
      }
    }
  }
</script>

<style lang="scss" scoped>
  .site-container {
    width: 100%;
    padding: 8px 15px 15px;
    box-sizing: border-box;
    .site-item {
      width: 100%;
      height: 100px;
      border-radius: 4px 0 0 4px;
      margin-bottom: 8px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .site-nav {
      width: 60px;
      height: 60px;
      position: fixed;
      right: 15px;
      bottom: 40px;
      background: #009A6D;
      border-radius: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .nav-img {
        width: 24px;
        height: 24px;
        margin: 0 auto;
      }
      .nav-text {
        font-weight: 400;
        font-size: 10px;
        color: #FFFFFF;
        margin-top: 4px;
      }
    }
  }
</style>